<div (click)="loading ? $event.stopPropagation() : null" [ngClass]="'stateful-button size-' + size + ' ' + classes" matRipple>
  <div class="stateful-button-text" [class.visible]="!loading">
    <ng-content></ng-content>
  </div>
  <div class="loading" [class.visible]="loading">
    <span class="iconify spin  inline-block" data-icon="fa:spinner"></span>
  </div>
</div>
